module.exports = __webpack_public_path__ + "static/media/collapse-button.340f7060.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collapse-button.svg
// module id = 1953
// module chunks = 1